<section>
  <div class="spinner" *ngIf="isLoading; else showBanner"></div>
  <ng-template #showBanner>
    <div class="content-wrapper" *ngIf="!pricingRetrievalError">
      <div class="banner-content">
        <h2 class="title">{{ banner?.title }}</h2>
        <p class="content">
          {{ banner?.excerpt }}
        </p>
        <div (click)="trackEvent()">
          <a class="button" [href]="banner?.external_cta_link">{{
            banner?.cta_text
          }}</a>
        </div>
      </div>
      <div class="offer-container">
        <img
          [src]="banner?.image?.data?.attributes?.url"
          alt="logo"
          class="logo"
          [class.svg-pos]="checkIsSvg"
        />
        <div class="offer">
          <h3 class="text">Exclusive offer from only</h3>
          <h2 class="pricing">{{ userPricing | currency: 'GBP' }}</h2>
        </div>
      </div>
    </div>
  </ng-template>
</section>
